import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import "./style.css";


//successful toast
const TODIS_SUCCESS_TOAST = (props) => {
    return (
        <ToastContainer position="bottom-end">
            <Toast className="d-inline-block mx-5 my-3" bg="sucess" key={0} onClose={() => props.onclosing()} style={success_styles} show={props.show} delay={3000} autohide>
                <Toast.Body >
                    <img src={props.image} width="20" className="todis-icon-left-btn" alt={props.title} />  {props.message}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    )
}

//danger toast
const TODIS_DANGER_TOAST = (props) => {
    return (
        <ToastContainer position="bottom-end" >
            <Toast className="d-inline-block mx-5 my-3" onClose={() => props.onclosing()} bg="danger" key={0} style={danger_styles} show={props.show} delay={3000} autohide >
                <Toast.Body className="text-white" >
                    <img src={props.image} width="20" className="todis-icon-left-btn" alt={props.title} />  {props.message}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    )
}


export { TODIS_SUCCESS_TOAST, TODIS_DANGER_TOAST };


//====================================================================================================================

const success_styles = {
    borderLeft: "5px solid #FFC61C",
    backgroundColor: "#FFDF80",
    borderRadius: "12px",
    color: "#004494",
    fontSize: "16px",
}

const danger_styles = {
    borderLeft: "5px solid #FB0000",
    backgroundColor: "#FF5E5E",
    borderRadius: "12px",
    fontSize: "16px",
}